import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { Observable, timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { UserModel } from '../modules/shared/model/userModel.model';
import { AccountService } from '../modules/shared/services/account.service';
import { isStringNullOrWhiteSpace } from '../util/StringUtil';

@Injectable({
    providedIn: 'root'
})
export class PasswordRequirementValidators {

    constructor(private accountService: AccountService) {
    }

    validate(): AsyncValidatorFn {
        return (control: AbstractControl): Promise<ValidationErrors | null> |
            Observable<ValidationErrors | null> => {
            const value: string = control.value;

            if (isStringNullOrWhiteSpace(value)) {
                return null;  // don't validate empty values to allow optional controls
            }
            let username: string;
            const parentForm = control.parent;
            if (parentForm) {
                const usernameControl = parentForm.controls["txbUserName"];
                username = usernameControl ? usernameControl.value : '';
            }
            username = username ?? 'PUBLICUSER0';

            const userModel = {
                Name: username,
                Pwd: value
            } as UserModel;

            return timer(100).pipe(switchMap(_ => this.accountService.validatePasswordRequisites(userModel).pipe(
                map(res => {
                    if (res.errorCode >= 100 && res.errorMessage) {
                        control.setErrors({
                            ...control.errors,
                            passwordReq: res.errorMessage
                        });
                        return { passwordReq: res.errorMessage };
                    } else {
                        if (control.errors?.passwordReq) {
                            control.setErrors(null);
                        }
                        return null;
                    }
                })
            )));

        };
    }
}
